import { Component } from '@angular/core';
import { NotificationBaseComponent } from 'app/shared/components/notifications/notification-base.component';

@Component({
    ...NotificationBaseComponent.metaData,
    selector: 'app-notification-alert-box-riester',
    templateUrl: './notification-alert-box-riester.component.html',
    styleUrls: ['./notification-alert-box-riester.component.scss'],
    standalone: false
})
export class NotificationAlertBoxRiesterComponent extends NotificationBaseComponent {
}
